import { HOST_STATIC } from "../common/const";
import { assign } from "../common/utils";

export function KUser(rawData) {
  const defaultLogo = '//' + HOST_STATIC + '/award/kline/img/2.2/avatar_not_logged_in.png';
  const R = assign(
    {
      uid: 0,
      nick: "未登录",
      oid: "",
      status: 0,
      gender: 0,
      logoAlbumId: 0,
      qrPid: 0,
      vip: 0,
      mobile: "",
      mobCountry: "",
      email: "",
      plat: 0,
      address: "",
      tel: "",
      username: "",
      logoLg: "", //大图:250
      logoMd: "", //中图:120
      logoSm: "", //小图:50
      logoSrc: "", //原图
      avatar: ""
    },
    rawData
  );
  R.nick = R.nick || "wz_" + R.uid;


  // 头像地址  
  if(!R.logoSrc) {//未格式化过，或原始值有logo
    let logo = rawData ? rawData.logo : null
    logo = logo || {
      src : defaultLogo,  // 默认头像地址
      thumb: defaultLogo,
      thumb120: defaultLogo,
      thumb50: defaultLogo
    };
    // logo = rawData.logo;
    R.logoSrc = R.logoSrc || logo.src || "";
    R.logoLg = R.logoLg || logo.thumb || R.logoSrc;
    R.logoMd = R.logoMd || logo.thumb120 || R.logoLg;
    R.logoSm = R.logoSm || logo.thumb50 || R.logoMd;
    R.avatar = R.logoMd;
  }

  return R;
}

// function TUserCoin(rawData) {
//   var R = {
//     coin: 0,
//     times: 0 //今日完成局数
//   };
//   R = XUtils.assign(R, rawData);
//   return R;
// }


// function TUserStats(rawData) {
//   var R = {
//     coins: 0,   // 金币值
//     empirics: 0 // 经验值
//   };
//   R = XUtils.assign(R, rawData);

//   R.coins = +R.extcredits2 || 0;
//   R.empirics = +R.extcredits3 || 0;
//   return R;
// }

// function TUserGroup(rawData) {
//   var R = {id: 0, title: "", isVip: 0};
//   R = XUtils.assign(R, rawData);
//   return R
// }
